export const matt = {
  id: 'matt',
  slug: 'matt-jensen',
  fullName: 'Matt Jensen',
  titles: ['Founder', 'Author'],
  shortBio: 'Passionate SaaS bootstrapper. Currently creating incredible tools for content creators.',
  avatarUrl: '/img/authors/matt-jensen.webp',
  socialUrls: ['https://twitter.com/mattwjensen', 'https://www.instagram.com/mr.mattjensen/', 'https://www.linkedin.com/in/mattwjensen/']
};
export const emily = {
  id: 'emily',
  slug: 'emily-tuipulotu',
  fullName: 'Emily Tuipulotu',
  titles: ['Author'],
  shortBio: 'She has extensive experience as a wedding coordinator, having organized countless weddings in Hawaii over a period of seven years. Nowadays, Emily works as a freelance writer who focuses on various aspects of weddings, as she continues to work as an onsite coordinator, attending multiple weddings each month.',
  avatarUrl: '/img/authors/emily-tuipulotu.png',
  socialUrls: ['https://www.brides.com/emily-sumners-tuipulotu-5221689']
};
export const sarah = {
  id: 'sarah',
  slug: 'sarah-bettencourt',
  fullName: 'Sarah Bettencourt',
  titles: ['Author'],
  shortBio: 'Sarah is a freelance writer specializing in content regarding wellness and beauty. Her versatile writting skills have been featured on established blogs such as beautybyearth.com & nutracelle.com.',
  avatarUrl: '/img/authors/sarah-bettencourt.jpg',
  socialUrls: []
};
export const kandice = {
  id: 'kandice',
  slug: 'kandice-vincent',
  fullName: 'Kandice Vincent',
  titles: ['Head of Content', 'Author'],
  shortBio: 'Experienced content manager with an extensive background in SEO and data-driven content marketing. Specializing in SaaS and technology, she helps businesses transform their data into compelling stories, leveraging it to drive engagement and growth.',
  avatarUrl: '/img/authors/kandice-vincent.jpg',
  socialUrls: ['https://www.linkedin.com/in/kandicevincent/', 'https://theconsciouscontentinitiative.com']
};
export default [matt, emily, sarah, kandice];